import { styled } from '@linaria/react';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	padding: 12px 12px 16px 16px;
	background: rgba(255, 255, 255, 0.09);
	border-radius: 16px;
`;

export const TitleContainer = styled.div`
	display: flex;
	justify-content: space-between;
`;

export const CloseButton = styled.button`
	width: 16px;
	height: 16px;
	color: var(--color-white-05);
	cursor: pointer;
`;
